import {
  FieldConfig,
  FieldDataTypes,
  MediaAssetTypeInterface,
  nString,
  uString,
  Uuid,
} from '@hidat/huijs-common';
import { ResourceConfig, SoftDeleteResource } from '@hidat/huijs-resource';
import {
  splixerFieldConfigs,
  splixerSystemFields,
} from './splixer-fields.const';
import { SplixerResourceInterface } from './splixer-resource.interface';

export const AssetTypeConfig = new ResourceConfig(
  'AssetType',
  'asset_types',
  true,
  true,
)
  .addFields(splixerSystemFields)
  .addFields([
    splixerFieldConfigs.name,
    splixerFieldConfigs.description,
    new FieldConfig('usageCode').setRequired(true),
    new FieldConfig('mediaType').setRequired(true),
    new FieldConfig('role'),
    new FieldConfig('repositoryId').setRequired(true),
    new FieldConfig('previewRepositoryId'),
    new FieldConfig('generatePreview', FieldDataTypes.BOOLEAN).setRequired(
      true,
    ),
    new FieldConfig('maxSize', FieldDataTypes.NUMBER),
    new FieldConfig('masterSettings', FieldDataTypes.HASH),
    new FieldConfig('previewSettings', FieldDataTypes.HASH),
  ]);

export interface AssetTypeInterface
  extends
    SplixerResourceInterface<Uuid>,
    SoftDeleteResource,
    MediaAssetTypeInterface {
  name: uString;
  description: nString;
  repositoryId: Uuid | undefined | null;
  previewRepositoryId: Uuid | undefined;
}
